import React, { useEffect, useState  } from "react";
import Features from "../Sub/Features";
import Footer from "../Sub/Footer";
import OnSaleProducts from "../Sub/OnSaleProducts";
import WebSlider from "../Sub/WebSlider";
import Review from "../Sub/Review";
import { Col, Container } from "react-bootstrap";
import BrandsLogo from "../Sub/BrandsLogo";
import homebanner from '../../images/homebanner.jpg';
import { useDispatch, useSelector } from "react-redux";
import {
  getHomePageSetting,
  getProductRating,
} from "../../reducers/commonReducer";
import Header from "../Sub/Header";
import Categories from "../Sub/Categories";
import MutualFundSection from "../Sub/MutualFundSection";
import ServicesSection from "../Sub/ServicesSection"
import WhyTaxNwealth from "../Sub/WhyTaxNwealth" 
import ValuedPartners from "../Sub/ValuedPartners" 
import ClientTestimonials from "../Sub/ClientTestimonials" 
import PricingPlans from "../Sub/PricingPlans"
import BlogSection from "../Sub/BlogSection"
import FaqSection from "../Sub/FaqSection"
import LoginPop from '../Sub/LoginPop';
import NotificationBar from '../Sub/NotificationBar'
import DisclaimerPopup from "../Sub/DisclaimerPopup";



const Home = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getHomePageSetting());
    dispatch(getProductRating());
  }, []);
  const { getHomePageSettingList } = useSelector(
    (state) => state.commonReducer
  );
  const { getCountProductData } = useSelector((state) => state.frontEndReducer);
  const [showLogin, setShowLogin] = useState(false);

  const handleLoginClick = () => {
    setShowLogin(true);
  };

  const handleClosePop = () => {
    setShowLogin(false);
  };
  return (
    <>
       <Header onLoginClick={handleLoginClick} />
       <NotificationBar />
       <WebSlider/>
      {/* <MutualFundSection /> */}
       <DisclaimerPopup />
      {/* <MutualFundSection /> */}
      <ServicesSection />
      <WhyTaxNwealth />
      <ValuedPartners />
      <ClientTestimonials />
      <PricingPlans />
      {/* <BlogSection /> */}
      <FaqSection />
      {showLogin && <LoginPop onClose={handleClosePop} />}
      <Footer />
    </>
  );
};

export default Home;
